import { DevelopmentFeatureFlags, PracticeFeatureFlags } from "../constants/feature-flags";
import useFeature from "../hooks/useFeature";

interface FeatureGateProps {
  children: React.ReactNode;
  name: PracticeFeatureFlags | DevelopmentFeatureFlags;
  fallback?: React.ReactNode;
}

export default function FeatureGate({ children, name, fallback = null }: FeatureGateProps) {
  const isEnabled = useFeature(name);

  if (!isEnabled) {
    return fallback ?? null;
  }

  return children;
}
